// extracted by mini-css-extract-plugin
var _1 = "RiskBannerStyle-module__closeBtn___PsoJ2";
var _2 = "RiskBannerStyle-module__riskBanner___pwfEO";
var _3 = "RiskBannerStyle-module__riskBannerNonUk___D8wXG";
var _4 = "RiskBannerStyle-module__riskBannerUk____8_O9";
export { _1 as "closeBtn", _2 as "riskBanner", _3 as "riskBannerNonUk", _4 as "riskBannerUk" }
